module.exports = __webpack_public_path__ + "static/media/tree (2).3e7591dc.jpg";